import type { FaireProductEntity } from "../../entity_types/product";

export const p_y9h3pmqvak: FaireProductEntity = {
  token: "p_y9h3pmqvak",
  type: "product",
  name: "Glass Match Cloche | Amber",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/0409f8fc1903d219e59968c8033075f3c67fd9640a9f9d0199110eafcb3de0b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b19a977da248641fb2a09d9fc6d370ab5adfe6d08f26d5b4270a08d4997d473.jpeg",
    "https://cdn.faire.com/fastly/2faeedeb096b14a2152696ca5bd9536f31c2a86151348645ded4fcd12d659a29.jpeg",
    "https://cdn.faire.com/fastly/814dca52cf0a7e5908d8829d061a34447e3b72623fc98b84e9e1e69c0589ef46.jpeg",
    "https://cdn.faire.com/fastly/167c7546d1f0c01f3c30595ebcf014931f4810ba7ce5245f5dbc78522771176b.jpeg",
  ],
  priceDollars: 16,
  description:
    'Versatile, functional & stylish, our match cloches make the perfect accompaniment to your favorite Botanica candle. Designed in chic colorways, they enhance any color-coordinated merchandising display. Each handblown glass vessel contains 120 white-tipped, wooden safety matches along with a handy honeycomb striker hidden on the backside. Our label is easily removable, making these eye-catching, colorful pieces ready for your mantle right out of the box.\n\n• Glass Color: Amber\n• 120 White-Tipped Safety Matches\n• Cloche Size: 7" Height x 3.125" Diameter \n• Cork Stopper & Striker \n• Removable Label\n\n• This product is only available to the 48 contiguous United States & Canada via Ground Delivery.\n\n\n\n\nKeywords for your SEO:\nMatchsticks, match holder, match striker, vintage matchbooks, holiday gift ideas, holiday gift, hostess gift, candle, candle accessories, kitsch, unique gifts, mantle decor, mantle decorations, fireplace matches, fireplace decor, home decor, spring, summer, fall, autumn, winter, gift sets, wedding gifts, wedding, holiday candles, Christmas candle decor, Christmas fireplace mantle decor, fireplace matchsticks, holiday hostess gifts, Christmas hostess gifts, winter gifts, gift guide',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:57.918Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
